<template>
  <Modal ref="modalRef" class="request-transfer-modal" @ok="requestTransferAsync">
    <template #title>Change owner</template>
    <label>Send a request to this user:</label>
    <UserItem ref="userSelectorRef" :user-id="dataGroupRef?.ownerId"/>
    <label>to transfer ownerhip of this {{ groupTypeTextRef }} to you:</label>
    <ProfileCard v-if="dataGroupRef?.isProfile" show-profile-type static :person-id="dataGroupRef.startItemId"/>
    <ResearchGroupItem v-else :data-group-id="dataGroupId"/>
    <template #okText>Transfer now</template>
  </Modal>
</template>

<style lang="scss" scoped>
:deep(.modal-body) {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.profile-card,
.research-group-item,
.user-item {
  margin-left: 1rem;
}
</style>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { notImplemented } from '@/util/AppUtil'
import Modal from '@/util/Modal.vue'
import ProfileCard from '../ProfileCard.vue'
import ResearchGroupItem from '../researchgroups/ResearchGroupItem.vue'
import UserItem from '../users/UserItem.vue'

const props = defineProps<{
  dataGroupId?: string,
}>()

const ownerIdRef = ref<string>()
const modalRef = ref<InstanceType<typeof Modal>>()

const dataGroupStore = useDataGroupStore()

const dataGroupRef = computed(() => dataGroupStore.getLoadedGroup(props.dataGroupId))
const groupTypeTextRef = computed(() => dataGroupRef.value?.isProfile ? 'profile' : 'tree')

async function requestTransferAsync() {
  try {
    notImplemented()
  }
  finally {
    modalRef.value?.reset()
  }
}
</script>
